import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "uk-card-small uk-card-default uk-margin-top uk-text-small" }
const _hoisted_2 = { class: "uk-card-body" }
const _hoisted_3 = { class: "uk-table uk-table-striped uk-table-small" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { class: "uk-padding-remove-left uk-padding-remove-right" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { "uk-tooltip": "Remove container" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  class: "uk-margin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "uk-card-header" }, [
      _createElementVNode("h3", { class: "uk-card-title" }, "Loads")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
          _createElementVNode("th", null, "Quantity"),
          _createElementVNode("th", null, "Package Type"),
          _createElementVNode("th", null, "Is Hazmat"),
          _createElementVNode("th", null, "Weight (lbs)"),
          _createElementVNode("th", null, "Commodity Description"),
          _createElementVNode("th", null, "NMFC No (LTL Only)"),
          _createElementVNode("th", null, "Class (LTL Only)")
        ], -1)),
        (_ctx.container != null)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.container.freightContents, (freightContent, freightContentIdx) => {
                return (_openBlock(), _createElementBlock("tr", { key: freightContentIdx }, [
                  _createElementVNode("td", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "uk-input uk-form-small uk-form-width-small",
                      placeholder: "Quantity",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.container.freightContents[freightContentIdx].quantity) = $event)
                    }, null, 8, _hoisted_6), [
                      [_vModelText, _ctx.container.freightContents[freightContentIdx].quantity]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "uk-input uk-form-small uk-form-width-small",
                      placeholder: "Package Type",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.container.freightContents[freightContentIdx].packingType) = $event)
                    }, null, 8, _hoisted_8), [
                      [_vModelText, _ctx.container.freightContents[freightContentIdx].packingType]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "uk-checkbox",
                      placeholder: "Is Hazmat",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.container.freightContents[freightContentIdx].isHazmat) = $event)
                    }, null, 8, _hoisted_10), [
                      [_vModelCheckbox, _ctx.container.freightContents[freightContentIdx].isHazmat]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "uk-input uk-form-small uk-form-width-small",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.container.freightContents[freightContentIdx].weight) = $event),
                      placeholder: "Weight (lbs)"
                    }, null, 8, _hoisted_12), [
                      [_vModelText, _ctx.container.freightContents[freightContentIdx].weight]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "uk-input uk-form-small uk-form-width-medium",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.container.freightContents[freightContentIdx].description) = $event),
                      placeholder: "Commodity Description"
                    }, null, 8, _hoisted_14), [
                      [_vModelText, _ctx.container.freightContents[freightContentIdx].description]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "uk-input uk-form-small uk-form-width-small",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.container.freightContents[freightContentIdx].nmfcNumber) = $event),
                      placeholder: "NMFC No"
                    }, null, 8, _hoisted_16), [
                      [_vModelText, _ctx.container.freightContents[freightContentIdx].nmfcNumber]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "uk-input uk-form-small uk-form-width-small",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.container.freightContents[freightContentIdx].nmfcClass) = $event),
                      placeholder: "NMFC Class"
                    }, null, 8, _hoisted_18), [
                      [_vModelText, _ctx.container.freightContents[freightContentIdx].nmfcClass]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("span", {
                      onClick: ($event: any) => (_ctx.removeFreightContents(0, freightContentIdx)),
                      "uk-icon": "minus-circle"
                    }, null, 8, _hoisted_20)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isDropAndHook)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addFreightContents(0))),
                class: "uk-button uk-button-secondary"
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { "uk-icon": "plus-circle" }, null, -1),
                _createTextVNode(" Load Item ", -1)
              ]))])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}